<template>
  <div>
    <SellHeader :img_header="header_image" header="แก้ไขล็อต-การส่งของ" :link_back="link_back"/>
    <Order_retail_edit/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/clipboard_2.png";
import Order_retail_edit from "@/components/admin/sell/Order_retail_edit";
export default {
  name: "OrderRetailEdit",
  components: {
    Order_retail_edit,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage,
      link_back: 'sell/confirmorderdetail/' + this.$route.params.id
    }
  },
}
</script>

<style scoped>

</style>
